import axios, { Method } from "axios";
import { stringify } from "query-string";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

export default function useHttp() {

    const baseUrl = `${publicRuntimeConfig.API_HOST}/api/v2/website`;

    const get = (url: string, payload: any = {}, config: any = {}, transformResponse?: any) => {
        return request("GET", url, payload, config, transformResponse);
    };

    const post = (url: string, payload: any = {}, config: any = {}, transformResponse?: any) => {
        return request("POST", url, payload, config, transformResponse);
    };

    const put = (url: string, payload: any = {}, config: any = {}, transformResponse?: any) => {
        return request("PUT", url, payload, config, transformResponse);
    };

    const destroy = (url: string, config: any = {}, transformResponse?: any) => {
        return request("DELETE", url, {}, config, transformResponse);
    };

    const request = (method: Method, url: string, payload: any, config: any, transformResponse?: any) => {
        const instance = axios.create({
            baseURL: baseUrl,
            timeout: 90000,
            timeoutErrorMessage: "Your connection timed out, please try again.",
            ...config,
        });

        instance.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            const apiError: {
                status: string,
                message: string,
                errors: any[],
                validationErrors: any[],
                code: number,
            } = {
                status: '',
                message: '',
                errors: [],
                validationErrors: [],
                code: 0,
            };

            if (error.response) {

                if (JSON.parse(error.response.data)) {
                    const data = JSON.parse(error.response.data);

                    apiError.status = data.status_code;
                    apiError.code = data.code;
                    apiError.message = data.message;

                } else {
                    const errorObject = error.response;

                    apiError.status = error.response.status;
                    apiError.code = errorObject.code;
                    apiError.message = errorObject.statusText;

                }


            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                console.log(error.request);
            } else {
                console.log(error);
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }

            return Promise.reject(apiError);
        });

        return instance.request({
            url: url.replace(/\/$/, ""),
            method,
            params: method == "GET" ? payload : {},
            transformResponse: transformResponse ? transformResponse : null,
            paramsSerializer: (params) => {
                return stringify(params, {
                    arrayFormat: "bracket",
                    skipEmptyString: true
                });
            },
            data: payload,
        });
    };

    return {
        get,
        post,
        put,
        delete: destroy,
        request,
    };
}
